// src/chat/CallOverlay.js
// Arama penceresi: gelen aramada kabul/ret, giden aramada iptal, görüşmede
// süre + sessize alma. Panelin her sayfasında sağ altta durur.
import React, { useEffect, useState } from "react";
import { initialsOf } from "../api/chatApi";
import { useCall } from "./CallProvider";
import "./CallOverlay.css";

const pad = (n) => String(n).padStart(2, "0");
const format = (ms) => { const s = Math.max(0, Math.floor(ms / 1000)); return `${pad(Math.floor(s / 60))}:${pad(s % 60)}`; };

export default function CallOverlay() {
  const call = useCall();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (call.status !== "active") return undefined;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [call.status]);
  if (call.status === "idle") return null;

  const remote = call.call?.other_user || {};
  const name = call.remoteName || remote.name || "Üye";
  const statusText = {
    outgoing: "Aranıyor…",
    incoming: "Gelen sesli arama",
    connecting: "Bağlanıyor…",
    active: call.startedAt ? format(now - call.startedAt) : "Görüşme sürüyor",
    ended: call.endedLabel || "Görüşme bitti",
  }[call.status];

  return (
    <div className={`co co--${call.status}`} role="dialog" aria-live="assertive" aria-label="Sesli arama">
      <div className="co-head">
        <span className="co-avatar">{remote.avatar ? <img src={remote.avatar} alt="" /> : initialsOf(name)}</span>
        <div className="co-id">
          <strong>{name}</strong>
          <small>{remote.subtitle || "Üye"}</small>
          <em className={call.status === "active" ? "co-timer" : ""}>{statusText}</em>
          {call.recording && <span className="co-rec"><i className="fa-solid fa-circle" /> Kayıt</span>}
        </div>
      </div>
      {call.error && call.status !== "ended" && <p className="co-error">{call.error}</p>}
      <div className="co-actions">
        {call.status === "incoming" && (
          <>
            <button className="co-btn co-btn--reject" onClick={call.rejectCall} aria-label="Aramayı reddet"><i className="fa-solid fa-phone-slash" /></button>
            <button className="co-btn co-btn--accept" onClick={call.acceptCall} aria-label="Aramayı kabul et"><i className="fa-solid fa-phone" /></button>
          </>
        )}
        {(call.status === "active" || call.status === "connecting") && (
          <button className={`co-btn co-btn--mute ${call.muted ? "is-on" : ""}`} onClick={call.toggleMute} aria-pressed={call.muted} aria-label={call.muted ? "Sesi aç" : "Sessize al"}>
            <i className={`fa-solid ${call.muted ? "fa-microphone-slash" : "fa-microphone"}`} />
          </button>
        )}
        {["outgoing", "connecting", "active"].includes(call.status) && (
          <button className="co-btn co-btn--reject" onClick={call.endCall} aria-label="Aramayı bitir"><i className="fa-solid fa-phone-slash" /></button>
        )}
      </div>
    </div>
  );
}
